import axios from 'axios';

export const uploadThumbnailFact = payload => {
  const url = '/fileuploader/generate-thumnail';
  return axios.post(url, payload);
};
